module.exports = __webpack_public_path__ + "img/hr-level1_mining_tool_shadow-1.ac00a1ed.png";